export default __webpack_public_path__ + "static/icons-bg-c46e8a9c4c2bbadb657b75638278d0a4.svg";